import { render, staticRenderFns } from "./ShopSvg.vue?vue&type=template&id=7c7679b0&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7679b0",
  null
  
)

export default component.exports